export enum State {
  AC = "AC",
  AL = "AL",
  AP = "AP",
  AM = "AM",
  BA = "BA",
  CE = "CE",
  DF = "DF",
  ES = "ES",
  GO = "GO",
  MA = "MA",
  MT = "MT",
  MS = "MS",
  MG = "MG",
  PA = "PA",
  PB = "PB",
  PE = "PE",
  PR = "PR",
  PI = "PI",
  RJ = "RJ",
  RN = "RN",
  RS = "RS",
  RO = "RO",
  RR = "RR",
  SC = "SC",
  SP = "SP",
  SE = "SE",
  TO = "TO",
  "AR-C" = "AR_C",
  "AR-Q" = "AR_Q",
  "AR-D" = "AR_D",
  "AR-S" = "AR_S",
  "AR-F" = "AR_F",
  "AR-K" = "AR_K",
  "AR-T" = "AR_T",
  "AR-H" = "AR_H",
  "AR-P" = "AR_P",
  "AR-Z" = "AR_Z",
  "AR-U" = "AR_U",
  "AR-M" = "AR_M",
  "AR-E" = "AR_E",
  "AR-J" = "AR_J",
  "AR-Y" = "AR_Y",
  "AR-G" = "AR_G",
  "AR-R" = "AR_R",
  "AR-W" = "AR_W",
  "AR-N" = "AR_N",
  "AR-A" = "AR_A",
  "AR-X" = "AR_X",
  "AR-B" = "AR_B",
  "AR-L" = "AR_L",
  "AR-V" = "AR_V",
  "PY-09" = "PY09",
  "PY-08" = "PY08",
  "PY-07" = "PY07",
  "PY-16" = "PY16",
  "PY-19" = "PY19",
  "PY-15" = "PY15",
  "PY-14" = "PY14",
  "PY-13" = "PY13",
  "PY-12" = "PY12",
  "PY-06" = "PY06",
  "PY-11" = "PY11",
  "PY-05" = "PY05",
  "PY-04" = "PY04",
  "PY-10" = "PY10",
  "PY-03" = "PY03",
  "PY-02" = "PY02",
  "PY-01" = "PY01",
  "PY-ASU" = "PY_ASU",
}

export const StateMapping = Object.fromEntries(Object.entries(State));

export const StateMappingReverse = Object.fromEntries(
  Object.entries(State).map(([k, v]) => [v, k]),
);
